module.exports = __webpack_public_path__ + "img/vacunas3.b0e880b3.jpg";